export const getHostDomain = () => {
  return process.env.REACT_APP_BASE_URL
}

export default getHostDomain

export const getHostFunctions = () => {
  return process.env.REACT_APP_API_URL
}
